import { defaultChatConfig, defaultChatConfigSpanishFields } from './five9ChatDefaultConfig'
import { defaultSurveyConfig } from './five9SurveyDefaultConfig'
import { Five9ChatConfig, Five9SurveyConfig, Five9AllConfig } from './five9-typings'

const chatConfig: { [key: string]: Five9ChatConfig & Five9SurveyConfig } = {
  'en-US': {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    profiles: 'US English Chat'
  },
  'es-US': {
    ...defaultChatConfig,
    ...defaultChatConfigSpanishFields,
    ...defaultSurveyConfig,
    title: 'Young Living Live Help - US/ES',
    profiles: 'US Spanish Chat',
    lang: 'https://five9-chat-dev.ecdev.youngliving.com/lang/five9-chat-lang-es.json',
    vivrURL: 'https://api.five9.com/ivr/1/131375/campaigns/1137788/new_ivr_session',
    sccProfileName: 'US Spanish Chat'
  },
  'en-CA': {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: 'Young Living Live Help - CA',
    profiles: 'Canada Chat',
    sccProfileName: 'Canada Chat',
  },
  "UK_Chat German": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - German",
    lang: 'https://five9-chat-dev.ecdev.youngliving.com/lang/five9-chat-lang-de.json',
    profiles: "UK_Chat German",
    sccProfileName: 'UK_Chat German',
    vivrURL: 'https://api.five9.com/ivr/1/131375/campaigns/1137913/new_ivr_session',
    fields: {
      "question": {
        value: "Hallo",
      },
      "Custom.MemberID": {
        label: "Mitgliedsnummer",
      },
      "Custom.MemberPIN": {
        label: "PIN",
      }
    },
  },
  "UK_Chat English": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - English",
    profiles: "UK_Chat English",
    sccProfileName: 'UK_Chat English',
  },
  "UK_Chat French": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - French",
    lang: 'https://five9-chat-dev.ecdev.youngliving.com/lang/five9-chat-lang-fr.json',
    profiles: "UK_Chat French",
    sccProfileName: 'UK_Chat French',
    vivrURL: "https://api.five9.com/ivr/1/131375/campaigns/1137916/new_ivr_session",
    fields: {
      "question": {
        value: "Bonjour",
      },
      "Custom.MemberID": {
        label: "Numéro de membre",
      },
      "Custom.MemberPIN": {
        label: "Code PIN",
      }
    },
  },
  "UK_Chat Dutch": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - Dutch",
    lang: 'https://five9-chat-dev.ecdev.youngliving.com/lang/five9-chat-lang-nl.json',
    profiles: "UK_Chat Dutch",
    sccProfileName: "UK_Chat Dutch",
    vivrURL: "https://api.five9.com/ivr/1/131375/campaigns/1137912/new_ivr_session",
    fields: {
      "question": {
        value: "Hallo",
      },
      "Custom.MemberID": {
        label: "Member nummer",
      },
      "Custom.MemberPIN": {
        label: "PIN",
      }
    },
  },
  "UK_Chat Romanian": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - Romanian",
    lang: 'https://five9-chat-dev.ecdev.youngliving.com/lang/five9-chat-lang-ro.json',
    profiles: "UK_Chat Romanian",
    sccProfileName: "UK_Chat Romanian",
    vivrURL: "https://api.five9.com/ivr/1/131375/campaigns/1137915/new_ivr_session",
    fields: {
      "question": {
        value: "Buna ziua",
      },
      "Custom.MemberID": {
        label: "Număr de Brand Partner",
      },
      "Custom.MemberPIN": {
        label: "PIN",
      }
    },
  },
  "UK_Chat Spanish": {
    ...defaultChatConfig,
    ...defaultChatConfigSpanishFields,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - Spanish",
    lang: 'https://five9-chat-dev.ecdev.youngliving.com/five9-chat-lang-es.json',
    profiles: "UK_Chat Spanish",
    sccProfileName: 'UK_Chat Spanish',
    vivrURL: 'https://api.five9.com/ivr/1/131375/campaigns/1137788/new_ivr_session'
  },
  "UK_Chat Russian": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - Russian",
    lang: 'https://five9-chat-dev.ecdev.youngliving.com/lang/five9-chat-lang-ru.json',
    profiles: "UK_Chat Russian",
    sccProfileName: "UK_Chat Russian",
    vivrURL: "https://api.five9.com/ivr/1/131375/campaigns/1137914/new_ivr_session",
    fields: {
      "question": {
        value: "Привет",
      },
      "Custom.MemberID": {
        label: "Номер парнера бренда",
      },
      "Custom.MemberPIN": {
        label: "Пин",
      }
    },
  },
  "UK_Chat Hungarian": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - Hungarian",
    lang: 'https://five9-chat-dev.ecdev.youngliving.com/lang/five9-chat-lang-hu.json',
    profiles: "UK_Chat Hungarian",
    sccProfileName: "UK_Chat Hungarian",
    vivrURL: "https://api.five9.com/ivr/1/131375/campaigns/1137917/new_ivr_session",
    fields: {
      "question": {
        value: "Helló",
      },
      "Custom.MemberID": {
        label: "Tagsági szám",
      },
      "Custom.MemberPIN": {
        label: "PIN kód",
      }
    },
  },
  "UK_Chat Portuguese": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - Portuguese",
    lang: 'https://five9-chat-dev.ecdev.youngliving.com/lang/five9-chat-lang-pt.json',
    profiles: "UK_Chat Portuguese",
    sccProfileName: "UK_Chat Portuguese",
    vivrURL: "https://api.five9.com/ivr/1/131375/campaigns/1137918/new_ivr_session",
    fields: {
      "question": {
        value: "Olá",
      },
      "Custom.MemberID": {
        label: "Número de membro",
      },
      "Custom.MemberPIN": {
        label: "PIN",
      }
    },
  },
  "UK_Chat Czech": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - Czech",
    lang: 'https://five9-chat-dev.ecdev.youngliving.com/lang/five9-chat-lang-cs.json',
    profiles: "UK_Chat Czech",
    sccProfileName: "UK_Chat Czech",
    vivrURL: "https://api.five9.com/ivr/1/131375/campaigns/300000000000041/new_ivr_session",
    fields: {
      "question": {
        value: "Ahoj",
      },
      "Custom.MemberID": {
        label: "Členské číslo",
      },
      "Custom.MemberPIN": {
        label: "PIN",
      }
    },
  },
  "en-ZA": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - Africa English",
    profiles: "ZA_Chat English",
    sccProfileName: "ZA_Chat English",
  },
  "en-MY": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - MY",
    profiles: "MY_Chat - English",
    sccProfileName: "MY_Chat - English",
    vivrURL: "https://api.five9.com/ivr/1/131375/campaigns/1137961/new_ivr_session"
  },
  "ms-MY": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - MY",
    profiles: "MY_Chat - English",
    sccProfileName: "MY_Chat - English",
    vivrURL: "https://api.five9.com/ivr/1/131375/campaigns/1137961/new_ivr_session"
  },
  "zh-MY": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - MY",
    profiles: "MY_Chat - English",
    sccProfileName: "MY_Chat - English",
    vivrURL: "https://api.five9.com/ivr/1/131375/campaigns/1137961/new_ivr_session"
  },
  "APAC_Chat - NFR": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - APAC NFR",
    profiles: "APAC_Chat - NFR",
    sccProfileName: "APAC_Chat - NFR",
    vivrURL: "https://api.five9.com/ivr/1/131375/campaigns/1137962/new_ivr_session"
  },
  "en-PH": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - Philippines English",
    profiles: "PHL_Chat - English",
    sccProfileName: "PHL_Chat - English",
  },
  "en-ID": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - Indonesia English",
    profiles: "IDN_Chat - English",
    sccProfileName: "IDN_Chat - English",
  },
  "id-ID": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - Indonesia Bahasa",
    profiles: "IDN_Chat - Bahasa Indonesia",
    sccProfileName: "IDN_Chat - Bahasa Indonesia",
    lang: 'https://five9-chat-test.ecdev.youngliving.com/lang/five9-chat-lang-id.json',
    vivrURL: "https://api.five9.com/ivr/1/131375/campaigns/1137970/new_ivr_session",
    fields: {
      "question": {
        value: "Halo",
      },
      "Custom.MemberID": {
        label: "Nomor anggota",
      },
      "Custom.MemberPIN": {
        label: "PIN",
      }
    },
  },
  "en-AU": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - Oceania English",
    profiles: "AU_Chat - Australia",
    sccProfileName: "AU_Chat - Australia",
  },
  "en-NZ": {
    ...defaultChatConfig,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - Oceania English",
    profiles: "AU_Chat - New Zealand",
    sccProfileName: "AU_Chat - New Zealand",
  },
  'es-EC': {
    ...defaultChatConfig,
    ...defaultChatConfigSpanishFields,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - Ecuador",
    lang: 'https://five9-chat-dev.ecdev.youngliving.com/five9-chat-lang-es.json',
    profiles: 'LATAM_Chat_EC',
    sccProfileName: 'LATAM_Chat_EC',
    vivrURL: 'https://api.five9.com/ivr/1/131375/campaigns/1137788/new_ivr_session'
  },
  'es-MX': {
    ...defaultChatConfig,
    ...defaultChatConfigSpanishFields,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - Mexico",
    lang: 'https://five9-chat-dev.ecdev.youngliving.com/five9-chat-lang-es.json',
    profiles: 'LATAM_Chat_MX',
    sccProfileName: 'LATAM_Chat_MX',
    vivrURL: 'https://api.five9.com/ivr/1/131375/campaigns/1137788/new_ivr_session'
  },
  'es-CO': {
    ...defaultChatConfig,
    ...defaultChatConfigSpanishFields,
    ...defaultSurveyConfig,
    title: "Young Living Live Help - Colombia",
    lang: 'https://five9-chat-dev.ecdev.youngliving.com/five9-chat-lang-es.json',
    profiles: 'LATAM_Chat_CO',
    sccProfileName: 'LATAM_Chat_CO',
    vivrURL: 'https://api.five9.com/ivr/1/131375/campaigns/1137788/new_ivr_session'
  }
  // ,'ja-JP': {
  //   ...defaultChatConfig,
  //   ...defaultSurveyConfig,
  //   title: "Young Living Live Help - Japan",
  //   lang: 'https://five9-chat-dev.ecdev.youngliving.com/lang/five9-chat-lang-jp.json',
  //   profiles: 'JPN_Chat - Japanese',
  //   sccProfileName: 'JPN_Chat - Japanese',
  //   fields: {
  //     "question": {
  //       value: "こんにちは",
  //     },
  //     "Custom.MemberID": {
  //       label: "会員番号",
  //     }
  //   },
  // }
}

const EmeaProfiles: { [locale: string]: string } = {
  "de-AT": "UK_Chat German",
  "hr-HR": "UK_Chat English",
  "cs-CZ": "UK_Chat Czech",
  "fi-FI": "UK_Chat English",
  "fr-FR": "UK_Chat French",
  "de-DE": "UK_Chat German",
  "lt-LT": "UK_Chat English",
  "nl-NL": "UK_Chat Dutch",
  "pl-PL": "UK_Chat English",
  "ro-RO": "UK_Chat Romanian",
  "es-ES": "UK_Chat Spanish",
  "sv-SE": "UK_Chat English",
  "en-GB": "UK_Chat English",
  "en-EU": "UK_Chat English",
  "ru-EU": "UK_Chat Russian"
}

// List includes both ISO country Alpha3 codes and Alpha2 codes https://www.iso.org/obp/ui/#search/code/ 
// for compatibility
const ApacNfrCountries: string[] = [
  "THA", "TH", // Thailand
  "BGD", "BD", // Bangladesh
  "BRN", "BN", // Brunei Darussalam
  "KHM", "KH", // Cambodia
  "FJI", "FJ", // Fiji
  "LAO", "LA", // Lao People's Democratic Republic (the)
  "MDV", "MV", // Maldives
  "MHL", "MH", // Marshall Islands (the)
  "FSM", "FM", // Micronesia (Federated States of)
  "MNG", "MN", // Mongolia
  "NPL", "NP", // Nepal
  "NCL", "NC", // New Caledonia
  "MNP", "MP", // Northern Mariana Islands (the)
  "PLW", "PW", // Palau
  "PNG", "PG", // Papua New Guinea
  "WSM", "WS", // Samoa
  "SYC", "SC", // Seychelles
  "SLB", "SB", // Solomon Islands
  "LKA", "LK", // Sri Lanka,
  "TON", "TO", // Tonga
  "VNM", "VN", // Viet Nam
  "WLF", "WF", // Wallis and Futuna
];

export function getConfig(locale: string, nfrCountryCode?: string): Five9AllConfig | undefined {
  const apacNfrProfile = nfrCountryCode && ApacNfrCountries.includes(nfrCountryCode)
    ? "APAC_Chat - NFR" : undefined;
  const emeaProfile = EmeaProfiles[locale];

  const configKey = apacNfrProfile ?? emeaProfile ?? locale;

  console.info(`[five9-chat] config key: ${configKey}`);

  const config = chatConfig[configKey]
  if (!config)
    return undefined
  return { ...config, defaultProfile: emeaProfile }
}
